import { CSSProperties, ReactNode } from 'react'

import { Paper, Stack } from '@mui/material'

import { Mixed } from '../Mixed'
import { EditTimeWindows } from './components/EditTimeWindows'

import { FormHeader } from './components/FormHeader'
import { useActions } from './hooks/useActions'
import { useTexts } from './hooks/useTexts'

import { BulkTimeWindowFieldValue } from '../../types'

type Props = {
  label: string
  testId?: string
  value: BulkTimeWindowFieldValue
  disabled: boolean
  error: boolean
  helperText: ReactNode
  validate: (force?: boolean) => void
  onChange: (value: BulkTimeWindowFieldValue) => void
}

const MainPaperStyle: CSSProperties = {
  background: '#F3F5F7',
  padding: '16px 8px',
}

export function TimeWindows(props: Props) {
  const {
    label,
    testId = 'traffic-timeWindows',
    value: fieldValue,
    disabled,
    error,
    helperText,
    validate,
    onChange,
  } = props

  const actions = useActions(fieldValue, onChange)
  const texts = useTexts()

  const addTimeWindowDisabled =
    fieldValue.status === 'mixed' ||
    (fieldValue.status === 'exact' && fieldValue.value.length === 2)

  const deleteAllTimeWindowsDisabled =
    fieldValue.status === 'exact' && fieldValue.value.length === 0

  return (
    <Stack data-testid={testId} data-trackid={testId} gap={2}>
      <FormHeader
        label={label}
        action={{
          label: texts.addTimeWindowsLabel,
          tooltip: texts.addTimeWindowTooltip,
          disabledTooltip: texts.addTimeWindowDisabledTooltip,
          onClick: actions.onAddTimeWindow,
          disabled: addTimeWindowDisabled,
        }}
        testId={`${testId}-section-header`}
      />

      {fieldValue.status === 'mixed' && (
        <Mixed
          onDeleteAllTimeWindows={actions.onDeleteAll}
          deleteAllTimeWindowsDisabled={deleteAllTimeWindowsDisabled}
        />
      )}

      {fieldValue.status === 'exact' && fieldValue.value.length > 0 && (
        <Paper elevation={0} sx={MainPaperStyle}>
          <EditTimeWindows
            onUpdateTimeWindow={actions.onUpdateTimeWindow}
            onRemoveTimeWindow={actions.onRemoveTimeWindow}
            validate={validate}
            value={fieldValue.value}
            disabled={disabled}
            error={error}
            helperText={helperText}
          />
        </Paper>
      )}
    </Stack>
  )
}
